<template lang="pug">
#confirmar-territorio
    p.m-0.pb-2(v-html='mensagemConfirmacao')

    .pb-4(v-if='territoriosSelecionados.length')
        .pt-2.flex.flex-column(
            v-for='(territorio, index) in territoriosSelecionados',
            :key='`territorio-${index}`'
        )
            b {{ territorio.nome }}
            em.pl-3(v-if='mostrarLocalidade') {{ territorio.localidade }}
            em.pl-3(v-if='mostrarRepresentantes') {{ territorio.totalRepresentantes }} {{ territorio.totalRepresentantes <= 1 ? $t('laudos.pessoaMinusculo') : $t('laudos.pessoasMinusculo') }}

    .botao(slot='footer')
        el-button(type='default', size='small', @click='voltar')
            | {{ $t('mensagens.comuns.cancelar') }}

        el-button(type='primary', size='small', @click='confirmar')
            | {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import TerritorioService from '@/services/TerritorioService';
import LaudosService from '@/modules/laudos/services/LaudosService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';

export default {
    name: 'ConfirmarTerritorio',
    props: {
        selecionados: {
            type: [Array, Object],
            default() {
                return [];
            },
            required: true
        },
        tipoLaudo: {
            type: Number,
            required: true
        }
    },

    emits: ['voltar'],

    computed: {
        mensagemConfirmacao() {
            const mensagens = {
                [TipoLaudo.AGRICOLA]: this.$t(
                    'laudos.confirmaSolicitacaoLaudoAgricolaParaSeguintesTerritorios'
                ),
                [TipoLaudo.AVALIACAO_DE_AREA_PRODUTIVA]: this.$t(
                    'laudos.confirmarSolicitacaoLaudoAvaliacaoAreaProdutiva'
                ),
                [TipoLaudo.AVALIACAO_SOCIOAMBIENTAL]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoAvaliacaoAmbiental'
                ),
                [TipoLaudo.DINAMICA_EXPLORACAO]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoDinamicaExploracao'
                ),
                [TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG]: this.$t(
                    'laudos.confirmarSolicitacaoDeSupressaoVegetalRedYellowFlag'
                ),
                [TipoLaudo.CARBONO]: this.$t(
                    'laudos.confirmarSolicitacaoLaudoCarbono'
                ),
                [TipoLaudo.DIAGNOSTICO_AGRICOLA]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoDiagnosticoAgricola'
                ),
                [TipoLaudo.HISTORICO_AGRICOLA]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoHistoricoAgricola'
                ),
                [TipoLaudo.SUPRESSAO_VEGETAL]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoSupressaoVegetal'
                ),
                [TipoLaudo.RELATORIO_TERRITORIAL]: this.$t(
                    'laudos.confirmarSolicitacaoDeLaudoRelatorioTerritorial'
                )
            };
            return mensagens[this.tipoLaudo] || '';
        },

        territoriosSelecionados() {
            const territoriosSelecionados =
                this.selecionados?.territoriosSelecionados || this.selecionados;

            return territoriosSelecionados;
        },

        mostrarLocalidade() {
            return this.tipoLaudo === TipoLaudo.SUPRESSAO_VEGETAL;
        },

        mostrarRepresentantes() {
            return this.tipoLaudo === TipoLaudo.SUPRESSAO_VEGETAL;
        }
    },

    methods: {
        voltar() {
            this.$emit('voltar');
        },
        obterTipoDocumento(cpfCnpj) {
            if (!cpfCnpj) {
                return null;
            }
            return cpfCnpj.length < 11 ? 'RUC' : 'CPF_CNPJ';
        },
        async confirmar() {
            const territoriosIds = this.territoriosSelecionados.map(
                territorio => territorio.id
            );

            try {
                const { data } = await TerritorioService.solicitacaoLaudo({
                    territoriosIds
                });

                let informacaoLaudos = data.map(territorio => {
                    const representante = territorio.representantes?.[0] || {};

                    return {
                        nomeRepresentante:
                            representante.nomeRazaoSocial || null,
                        cpfCnpjRepresentante: representante.cpfCnpj || null,
                        tipoDocumentoRepresentante: this.obterTipoDocumento(
                            representante.cpfCnpj
                        ),
                        territorioId: territorio.id,
                        tipoLaudoId: this.tipoLaudo
                    };
                });

                if (this.tipoLaudo === TipoLaudo.AVALIACAO_SOCIOAMBIENTAL) {
                    informacaoLaudos = informacaoLaudos.map(territorio => ({
                        ...territorio,
                        camadasId: [this.selecionados.camadaId],
                        observacao: this.selecionados.observacao || null,
                        safraId: this.selecionados.safraId,
                        culturaId: this.selecionados.culturaId
                    }));
                }

                if (this.tipoLaudo === TipoLaudo.SUPRESSAO_VEGETAL_RED_YELLOW_FLAG) {
                    informacaoLaudos = informacaoLaudos.map(territorio => ({
                        ...territorio,
                        observacao: this.selecionados.observacao || null
                    }));
                }

                if (this.tipoLaudo === TipoLaudo.DINAMICA_EXPLORACAO) {
                    informacaoLaudos = informacaoLaudos.map(territorio => ({
                        ...territorio,
                        camadasId: [this.selecionados.camadaId],
                        observacao: this.selecionados.observacao || null,
                        safraId: this.selecionados.safraId,
                        dataInicioCobertura:
                            this.selecionados.dataInicioCobertura,
                        dataFimCobertura: this.selecionados.dataFimCobertura,
                        culturaId: this.selecionados.culturaId
                    }));
                }

                await LaudosService.cadastrarLaudos({ informacaoLaudos });

                this.$notify.success({
                    message: this.$t('laudos.solicitacaoRealizadaComSucesso')
                });
                this.voltar();
            } catch (error) {
                this.$notify.error({
                    message:
                        error.response?.data?.mensagem ||
                        this.$t('laudos.ocorreuUmErroAoBuscarTerritorios')
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#confirmar-territorio {
    .botao {
        display: flex;
        justify-content: right;
        gap: 10px;
    }
}
</style>
